"use client";

import { useEffect, useState } from "react";
import { selectIsAuthSuccessOrPerpetual, useAppSelector } from "@repo/web-store";
import { getRecentlyViewedStocks } from "../../services/TradingMallService";
import type { ComponentContent } from "../../types/stocks";
import {
  textEllipsis,
  TITLE_CHAR_LIMIT,
} from "../ClpStockCards/clpCardConstant";
import { RecentlyViewedClient } from "./RecentlyViewedClient";
import type { RecentlyViewedStockItem } from "./recentlyViewedTypes";
import { RECENTLY_VIEWED_DEFAULT_SECTION_TITLE } from "./recentlyViewedTypes";
import { mapLastVisitedToStocks } from "./recentlyViewedUtils";

interface RecentlyViewedContainerProps {
  content?: ComponentContent;
}

const RecentlyViewedContainer = ({ content }: RecentlyViewedContainerProps) => {
  const isAuthSuccessOrPerpetual = useAppSelector(
    selectIsAuthSuccessOrPerpetual,
  );
  const [stocks, setStocks] = useState<RecentlyViewedStockItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStocks = async () => {
      if (!isAuthSuccessOrPerpetual) {
        setStocks([]);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      const data = await getRecentlyViewedStocks();
      setStocks(mapLastVisitedToStocks(data).reverse());
      setIsLoading(false);
    };
    fetchStocks();
  }, [isAuthSuccessOrPerpetual]);

  if (!isAuthSuccessOrPerpetual || (!isLoading && stocks.length === 0)) {
    return null;
  }

  const sectionTitle = textEllipsis(
    content?.componentTitle ?? RECENTLY_VIEWED_DEFAULT_SECTION_TITLE,
    TITLE_CHAR_LIMIT,
  );

  return (
    <section className="pl-4 py-3">
      <h2 className="pb-3 text-[18px] font-medium text-gray-900 lg:text-[#222F3F] md:text-[20px]">
        {sectionTitle}
      </h2>
      <RecentlyViewedClient
        stocks={stocks}
        isLoading={isLoading}
        errorMessage={content?.stockNotFoundText}
        stockNotFoundImgUrl={content?.stockNotFoundImgUrl}
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg}
        sectionTitle={sectionTitle}
        componentPosition={content?.componentPosition}
      />
    </section>
  );
};

export default RecentlyViewedContainer;
